module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA7klEQVR42mNgGAogYQEqf/XZCjMgrgfiiVDaDE3eASreD6XtqeogqKH/kXA9KfKU+FwXavgFNAsuQMVloOrK0OTbaeVzdJwPVZdPUQjg8flFNIP/ovEPQNVto0oUkOBzQrie2j7/R4D/nyohQAWfE+cACnxOLC7DZx8tfU5aFNDA5zB8AmquHt6QoIHPiQsJoIQdtNx+RCCfk4rR9T+C2mNHb5/jDwmggAfUZR1Qx+yjsoX7oOZ2QO3xGJy5AMkB5VR2QDkx5c+gCoFRB4w6YNQBow5op7ID2odcCNhDHdEOpcnF7TTpG9KtF0wP8wGbUJlq95gnLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_uni_sin.png
// module id = VyIZ
// module chunks = 0